<template>
  <div
    class="input-date input-text input-text--with-unit"
    :class="{'input-text--error': error}"
    @focusout="onWrapFocusOut"
  >
    <VueDatePicker
      v-bind="datepickerAttrs"
      :uid="id"
      v-model="localValue"
      :locale="language"
      :enable-time-picker="false"
      :auto-apply="true"
      :clearable="true"
      :format="dateFormat"
      :preview-format="dateFormat"
      input-class-name="input-text__input"
      calendar-class-name="input-date__calendar"
      autocomplete="off"
    />
  </div>
</template>

<script>
  import {DateTime} from 'luxon';
  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css';

  import globals from '../../lib/globals';
  import ExIcon from '../icons/ExIcon.vue';

  export default {
    components: {
      VueDatePicker,
      ExIcon
    },
    inheritAttrs: false,
    data() {
      return {
        language: globals.language || 'fi',
        dateFormat: 'dd.MM.yyyy',
      }
    },
    props: {
      id: {
        type: String,
        default: null,
      },
      modelValue: {
        type: String, // yyyy-mm-dd
        default: null,
      },
      error: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue', 'blur'],
    computed: {
      /** Do not forward blur listeners to VueDatePicker — they fire on inner input and break Vuelidate touch timing. */
      datepickerAttrs() {
        const attrs = { ...this.$attrs };
        delete attrs.onBlur;
        delete attrs.onFocusout;
        delete attrs.onFocusOut;
        return attrs;
      },
      localValue: {
        get () {
          return this.modelValue ? DateTime.fromISO(this.modelValue).toJSDate() : null;
        },
        set (newValue) {
          if (newValue) {
            this.$emit('update:modelValue', DateTime.fromJSDate(newValue).toISODate());
          } else {
            this.$emit('update:modelValue', null);
          }
        }
      },
    },
    methods: {
      /**
       * Emit blur only when focus truly leaves this control (not when moving to the
       * teleported calendar menu, which lives outside this.$el).
       */
      onWrapFocusOut() {
        this.$nextTick(() => {
          const ae = document.activeElement;
          if (ae && this.$el.contains(ae)) {
            return;
          }
          if (ae?.closest?.('.dp__menu, .dp--menu-wrapper')) {
            return;
          }
          this.$emit('blur');
        });
      },
    },
  };
</script>

<style lang="scss">
  @import "~styles/definitions";

  .input-date__calendar {
    @include card;
    margin-top: r(4);
  }

  .input-date__clear {
    @include reset-button(true);
    transition: transform 0.2s;

    &:focus {
      transform: scale(1.2);
    }
  }

  // Vue Datepicker customizations
  .dp__theme_light {
    --dp-primary-color: #{$color-primary};
    --dp-primary-text-color: #{$color-white};
  }

  .dp--clear-btn {
    .dp__icon {
      fill: $color-black;
    }
  }
</style>
